module.exports = __webpack_public_path__ + "img/bottom-triangle.c516fed4.png";